'use strict';

(function () {
  'use strict';

  angular.module('msUtility').filter('percent', PercentFilter);

  /**
   *
   */
  function PercentFilter() {
    return function (top, bottom) {
      if (!_.isNumber(top)) {
        return '0%';
      }
      if (!_.isNumber(bottom)) {
        bottom = 100;
      }
      var percent = Math.floor(100 * top / bottom);
      return Math.min(100, percent) + '%';
    };
  }
})();